import Immutable from 'immutable';
import webapi from '../../webapi';
import { createModelForState, createModuleState } from '../moduleregistry';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('EntitySearchAndDetail');

export default class EntitySearchAndDetailModel {
	#data;

	static get NEW_ROW_MODE_NONE() {
		return 0;
	}

	static get NEW_ROW_MODE_EMPTY() {
		return 1;
	}

	static get NEW_ROW_MODE_LOAD_NULL_ID() {
		return 2;
	}

	constructor(data = null) {
		this.#data = data || EMPTY_MAP;
	}

	getData() {
		return this.#data;
	}

	setNewRowMode(value) {
		return new EntitySearchAndDetailModel(this.#data.set('newRowMode', value));
	}

	setEntityName(value) {
		let model = new EntitySearchAndDetailModel(this.#data.set('entityName', value));
		let search = this.getSearch();
		if (search) {
			model = model.setSearch(search.setEntityName(value));
		}
		let detail = this.getDetail();
		if (detail) {
			model = model.setDetail(detail.setEntityName(value));
		}
		return model;
	}

	getEntityName() {
		return this.#data.get('entityName');
	}

	setSearch(search) {
		const entityName = this.getEntityName();
		if (entityName) {
			search = search.setEntityName(entityName);
		}
		return new EntitySearchAndDetailModel(this.#data.set('search', search.getState()));
	}

	setDetail(detail) {
		const entityName = this.getEntityName();
		if (entityName) {
			detail = detail.setEntityName(entityName);
		}
		return new EntitySearchAndDetailModel(this.#data.set('detail', detail.getState()));
	}

	getSearch() {
		return createModelForState(this.#data.get('search'));
	}

	getDetail() {
		return createModelForState(this.#data.get('detail'));
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}

	async showNewDetail() {
		const newRowMode = this.#data.get('newRowMode');
		if (!newRowMode) {
			return this;
		}
		let detailModel = this.getDetail();
		if (newRowMode === EntitySearchAndDetailModel.NEW_ROW_MODE_LOAD_NULL_ID) {
			detailModel = await detailModel.loadDetail(null);
		} else {
			detailModel = detailModel.setEmptyDetail();
		}
		detailModel = await detailModel.onNewEntity();
		return new EntitySearchAndDetailModel(this.#data.setIn(['detail', 'data'], detailModel.getData()).set('isDetailOpen', true));

	}

	async showDetail(id) {
		let detailModel = this.getDetail();
		detailModel = await detailModel.loadDetail(id);
		return new EntitySearchAndDetailModel(this.#data.setIn(['detail', 'data'], detailModel.getData()).set('isDetailOpen', true));
	}

	hideDetail() {
		return new EntitySearchAndDetailModel(this.#data.set('isDetailOpen', false));
	}
}

